<template>
<div v-show="isLoaded" id="mobile-retailer" class="mMobile-retailer-section" v-observe-visibility="startAnimate">
    <div class="mSection-title">
      <h2 class="title">Dónde Comprar</h2>
  </div>
  <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide><a href="https://super.walmart.com.mx/productos?Ntt=strongbow&utm_source=mtz_heineken&utm_medium=mtz_landing&utm_campaign=mtz_heineken_lf_strongbow_20210311&utm_content=boton&utm_term=landing" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Walmart')"><img :src="Walmart" alt="Walmart"></a></swiper-slide> 
    <swiper-slide><a href="https://www.amazon.com.mx/stores/page/AF95D68F-7974-4D85-84BB-C8BC7A147B02?ingress=2&visitId=2a2f2085-fc5e-4791-8117-2041f32fe18a&ref_=ast_bln" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Amazon')"><img :src="Amazon" alt="Amazon"></a></swiper-slide>
    <swiper-slide><a href="https://articulo.mercadolibre.com.mx/MLM-869078325-sidra-strongbow-variety-pack-16-botellas-de-330-ml-_JM?fbclid=IwAR1WMcgMMzS-uqrksFyZwudZwC_78WUktTjelX8MpPt-H5FZ-ZZaJRlcVCE#position=14&search_layout=grid&type=item&tracking_id=3422032d-a96c-4605-9deb-e71726324ec9" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Mercadolibre')"><img :src="MercadoLibre" alt="Mercadolibre"></a></swiper-slide>
    <swiper-slide><a href="https://www.soriana.com/buscar?q=strongbow&cid=&search-button=&page=1" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Soriana')"><img :src="Soriana" alt="Soriana"></a></swiper-slide>
    <swiper-slide><a href="https://web.cornershopapp.com/stores-search/STRONGBOW?fbclid=IwAR0AF93cNRARYF3XMwnQ9Cezanxp0l1thjbIBWIwQJLB1Lx9HiSJRwEzs_k" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Cornershop')"><img :src="Cornershop" alt="Cornershop"></a></swiper-slide>
    <swiper-slide><a href="https://glup.com/" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Glup')"><img :src="Glup" alt="Glup"></a></swiper-slide> 
    <!-- <swiper-slide><a href="https://www.heb.com.mx/catalogsearch/result/?q=strongbow" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Heb')"><img :src="Heb" alt="Heb"></a></swiper-slide> -->
    <!-- <swiper-slide><a href="javascript:void(0)" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Rappi')"><img :src="Rappi" alt="Rappi"></a></swiper-slide>  -->
    <!--<swiper-slide><a href="https://www.sixtogo.com.mx/catalogsearch/result/?q=strongbow" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('SixToGo')"><img :src="SixToGo" alt="SixToGo"></a></swiper-slide>-->
    <!-- <swiper-slide><a href="javascript:void(0)" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Bodega')"><img :src="Bodega" alt="Bodega"></a></swiper-slide> -->
    <!-- <swiper-slide><a href="javascript:void(0)" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('CityClub')"><img :src="CityClub" alt="CityClub"></a></swiper-slide> -->
    <!-- <swiper-slide><a href="javascript:void(0)" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('Costco')"><img :src="Costco" alt="Costco"></a></swiper-slide> -->
    <!-- <swiper-slide><a href="javascript:void(0)" target="_blank" rel="noopener" class="retail-link" @click="retailerClick('SamsClub')"><img :src="SamsClub" alt="SamsClub"></a></swiper-slide>  -->
    <div class="swiper-scrollbar" slot="scrollbar"></div>
  </swiper>
</div>
</template>

<script>
import Amazon from "@/assets/Amazon.png";
import Cornershop from "@/assets/Cornershop.png";
import Heb from "@/assets/HEB_ONLINE.png";
import MercadoLibre from "@/assets/Mercado_Libre.png";
import Rappi from "@/assets/Rappi.png";
import SixToGo from "@/assets/SixtoGo.png";
import Walmart from "@/assets/WM_ONLINE.png";
import Bodega from "@/assets/BodegaAurrera.png";
import Soriana from "@/assets/SORIANA.png";
import CityClub from "@/assets/City_Club.png";
import Costco from "@/assets/Costco.png";
import SamsClub from "@/assets/Sams_Club.png";
import Glup from "@/assets/glup.png";
import tagFunctions from '@/utils/tagFunctions.js'
import { mapGetters } from "vuex";
import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'


export default {
  name: "MobileRetailers",
  components: {
    Swiper, SwiperSlide
  },
  data() {
    return {
      Amazon,
      Cornershop,
      Heb,
      MercadoLibre,
      Rappi,
      SixToGo,
      Walmart,
      Bodega,
      Soriana,
      CityClub,
      Costco,
      SamsClub,
      Glup,
      animate: false,
       swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
        centeredSlidesBounds: false,
        centerInsufficientSlides	:false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            draggable: true,
            snapOnRelease: true,
          }
        }
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  mounted() {
    
  },
  methods:{
    retailerClick(storeName){
      tagFunctions.evib2cOutboundlinkPush(storeName)
    },
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/mobileretailerm.scss";
</style>

<style lang="scss">
.mMobile-retailer-section{
.swiper-scrollbar-drag{
  background: black;
}}
</style>
